import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createCsrfToken, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { IAuthorizationData } from "../@types";
import AuthenticationURIBuilder from "./AuthenticationURIBuilder";

export interface IAuthorizePasswordRequest {
  password: string;
  nextURI: string;
  operation: string;
  context: { [key: string]: string };
}

export interface IAuthorizePasswordOpts extends RequestInit {
  apiUrl: string;
  apiKey?: string;
  sessionKey: string;
  ctrl?: QueryController;
}

export const createRequest = (body: IAuthorizePasswordRequest, opts: IAuthorizePasswordOpts): Request => {
  const { apiUrl, apiKey, sessionKey, ...restOpts } = opts;
  const { password, nextURI, operation, context } = body;
  const url = new AuthenticationURIBuilder().setApiUrl(apiUrl).setSegment(["password", "authorize"]);

  const headers = createHeaders({
    "ARGUS-API-KEY": apiKey,
    Accept: "application/json",
    "Content-type": "application/json",
    "ARGUS-CSRF-Token": !apiKey ? createCsrfToken(sessionKey, String(url)) : false,
  });

  const localRequestOpts: RequestInit = {
    body: JSON.stringify({ password, nextURI, operation, context }),
    credentials: "include",
    headers,
    method: "POST",
    mode: "cors",
  };

  return new Request(String(url), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function authorizePassword(
  body: IAuthorizePasswordRequest,
  opts: IAuthorizePasswordOpts,
): Promise<JsonQuery<IResultstash<IAuthorizationData>>> {
  return await fetchJsonQuery<IResultstash<IAuthorizationData>>(createRequest(body, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default authorizePassword;
